import React, { Fragment } from 'react'
import { Form, Input, Select } from 'antd'
import { STATES } from '@reggora_shared_ui/constants/locations'
import styles from './AddressForm.module.scss'

const { Option } = Select

const labelCol = { span: 24 }

const stateOptions = Object.keys(STATES).map(stateCode => (
  <Option
    value={stateCode}
    key={stateCode}>
      {STATES[stateCode]}
  </Option>
))

const AddressForm = ({
  addressPrefix = '',
  initialValues: {
    address,
    city,
    state,
    zip,
  } = {},
}) => (
  <Fragment>
    <Form.Item
      label='Street Address'
      labelCol={labelCol}
      name={`${addressPrefix}address`}
      initialValue={address}
      rules={[{
        required: true,
        message: 'Please enter your street address',
      }]}
    >
      <Input
        name={`${addressPrefix}address`}
      />
    </Form.Item>
    <Form.Item
      label='City'
      labelCol={labelCol}
      name={`${addressPrefix}city`}
      initialValue={city}
      rules={[{
        required: true,
        message: 'Please enter your city',
      }]}
    >
      <Input
        name={`${addressPrefix}city`}
      />
    </Form.Item>
    <Form.Item
      label='State'
      labelCol={labelCol}
      name={`${addressPrefix}state`}
      initialValue={state}
      rules={[{
        required: true,
        message: 'Please select your state',
      }]}
    >
      <Select
        className={styles.stateSelect}
        name={`${addressPrefix}state`}
        showSearch
        placeholder='Select A State'
        optionFilterProp='children'
      >
        {stateOptions}
      </Select>
    </Form.Item>
    <Form.Item
      className={styles.zipCodeFormItem}
      label='Zip Code'
      labelCol={labelCol}
      name={`${addressPrefix}zip`}
      initialValue={zip}
      rules={[{
        required: true,
        type: 'regexp',
        pattern: new RegExp(/\d{5}/g),
        message: 'Please enter your 5 digit zip code',
      }]}
    >
      <Input
        className={styles.zipCodeInput}
        name={`${addressPrefix}zip`}
      />
    </Form.Item>
  </Fragment>
)

export default AddressForm
